import {Injectable} from '@angular/core';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {Project} from '@docma-mm-core/project/project';
import {catchError, of} from 'rxjs';

@Injectable()
export class SearchIdService extends BasedataService
{
  private projectUrl: string = '/projects/';
  private searchidUrl: string = '/searchids/';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  isValid(project: Project, searchId: number) {
    const endpoint = super.getFullUrl(this.projectUrl + project.Id + this.searchidUrl + searchId + '/isvalid');

    return this.http
      .get<boolean>(endpoint, { headers: this.getHeaders(), params: new HttpParams() })
      .pipe(catchError(e  => of(false) ));
  }

}
